import AWS from 'aws-sdk';
import { Auth } from '@aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import Lambda from 'aws-sdk/clients/lambda'; // npm install aws-sdk
import * as CertificatePortalAccessConstants from '../data/CertificatePortalAccessConstants.js';
import * as AuthConstants from '../data/AuthConstants.js';

AWS.config.region = CertificatePortalAccessConstants.AWS_REGION_NAME;

Amplify.configure({
    Auth: {
        mandatorySignIn: false,
        region: CertificatePortalAccessConstants.AWS_REGION_NAME,
        userPoolId: AuthConstants.AUTH_USER_POOL_ID,
        userPoolWebClientId: AuthConstants.AUTH_CLIENT_ID,
        identityPoolId: AuthConstants.AUTH_IDENTITY_POOL_ID
    },
});

async function getPortalAccessStatus(){
    let errorMsg = '';

    const params = {
        method: CertificatePortalAccessConstants.AWS_LAMBDA_GET_PARAMETER_METHOD_NAME,
        params: {
            paramName: CertificatePortalAccessConstants.AWS_SSM_PARAMETER_NAME
        }
    }

    try {
        const result = await execute(params);
        const resultJSON = JSON.parse(result.Payload);

        if(!resultJSON || resultJSON.errorMsg){
            errorMsg = resultJSON?.errorMsg;
            console.error(errorMsg);

        } else if(resultJSON.body) {
            const ssmParam = JSON.parse(resultJSON.body);
            let resultLabel = (ssmParam.Parameter.Value === CertificatePortalAccessConstants.PARAMETER_LOCK_VALUE)
                ? CertificatePortalAccessConstants.PORTAL_LOCK_LABEL
                : CertificatePortalAccessConstants.PORTAL_UNLOCK_LABEL;

            return {
                label: resultLabel,
                value: ssmParam.Parameter.Value
            }
        }

    } catch (error) {
        errorMsg = error;
    }

    return {
        label: 'Error al recuperar la información de acceso al portal',
        value: errorMsg
    }
}

async function setPortalAccessStatus(status){
    let errorMsg = '';

    const params = {
        method: CertificatePortalAccessConstants.AWS_LAMBDA_SET_PARAMETER_METHOD_NAME,
        params: {
            paramName: CertificatePortalAccessConstants.AWS_SSM_PARAMETER_NAME,
            paramValue: status
        }
    }

    try {
        const result = await execute(params);
        const resultJSON = JSON.parse(result.Payload);
        console.log(resultJSON);
        if(!resultJSON || resultJSON.errorType){
            errorMsg = resultJSON.errorType + ': ' +resultJSON.errorMessage;
            console.error(errorMsg);

        } else {
            return {
                label: 'La información de acceso al portal ha sido actualizada',
                success: true,
                value: status
            }
        }

    } catch (error) {
        console.error(error);
        errorMsg = error;
    }

    return {
        label: 'Error al actualizar la información de acceso al portal',
        success: false,
        value: errorMsg
    }
}

async function execute(parameters){
    const credentials = await Auth.currentCredentials();

    const lambda = new Lambda({
        credentials: Auth.essentialCredentials(credentials)
    });

    return lambda.invoke({
        FunctionName: CertificatePortalAccessConstants.AWS_LAMBDA_NAME,
        Payload: JSON.stringify({
            'Details': {
                'Parameters': parameters
            }
        })
    }).promise();
}

export { getPortalAccessStatus, setPortalAccessStatus }

